<template>
    <div class="card-container">
        <div class="flex-row vertical-center flow-justify">
            <el-button type="default" class="button-size" @click="$router.go(-1)">返回上一级</el-button>
            <el-button type="primary" class="button-size" @click="handleSelectStatus" v-if="allMoney != alreadyMoney">人工追回</el-button>
        </div>

        <el-row class="flow-justify plan-label flow-wrap">
            <!--<p>总金额（元）：<span>{{toDoubleThousands(notice.repayTotalAmt)}}</span></p>-->
            <!--<p>手续费（元）：<span>{{toDoubleThousands(notice.repayTotalAmt)}}</span></p>-->
            <p>总金额（元）：<span>{{toDoubleThousands(allMoney)}}</span></p>
            <p>已追回金额（元）：<span>{{toDoubleThousands(alreadyMoney)}}</span></p>
            <p>未追回金额（元）：<span>{{toDoubleThousands(allMoney - alreadyMoney)}}</span></p>
        </el-row>

        <common-table :data="tableData" :isShow="false" ref="commonTable" @handleChange="getList" class="common">
            <el-table-column prop="repayType" label="追款类型" show-overflow-tooltip>
                <template slot-scope="scope">
                    <p>{{scope.row.repayType == 1 ? '人工' : '自动'}}</p>
                </template>
            </el-table-column>
            <el-table-column prop="money" label="交易金额（元）" min-width="110" show-overflow-tooltip>
                <template slot-scope="scope">
                    <p>{{toDoubleThousands(scope.row.money * 100 / 10000)}}</p>
                </template>
            </el-table-column>
            <el-table-column prop="createTime" label="还款日期" min-width="160" show-overflow-tooltip></el-table-column>
            <el-table-column prop="proportion" label="追款比例（%）" min-width="100" :formatter="formatTranTypee" show-overflow-tooltip></el-table-column>
            <el-table-column prop="remark" label="失败原因" min-width="100"  :formatter="formatTranTypee" show-overflow-tooltip></el-table-column>
            <el-table-column prop="status" label="状态" min-width="80" show-overflow-tooltip>
                <template slot-scope="scope">
                    <p :class="scope.row.status == 1 ? 'text-red' : 'text-green'" v-if="scope.row.status">{{scope.row.status == 1 ? '成功' :
                        '失败'}}</p>
                    <p v-else>处理中</p>
                </template>
            </el-table-column>
        </common-table>
        <form-dialog ref="formDialog" formDialogTitle="人工追回" :model="dialogModel"
                     :dialogService="dialogService" :submitData="dialogData" :rules="dialogRules"
                     @success="dialogSuccess" @close="dialogClose" class="note">

            <el-form-item label="金额" prop="amount">
                <el-input-number v-model="dialogModel.amount" :controls="false" controls-position="right" :precision="2" :step="0.1" :min="0" style="width: 91%"></el-input-number>
                <span>元</span>
            </el-form-item>
        </form-dialog>
    </div>
</template>

<script>

    import CommonTable from 'components/common/CommonTable'
    import FormDialog from '../../dialog/FormDialog'

    import OrganService from 'service/OrganService'
    import ChannelRateService from 'service/ChannelRateService'
    import EmptyService from 'service/EmptyService'
    import privateKey from 'service/constant/privateKey'
    import planDetailStatus from 'service/constant/planDetailStatus'
    import {encrypt, urlEncode, objKeySort} from "common/js/common-utils";
    import {loadMixin, dialogMixin, validatorsMixin} from "mixin";
    import StorageService from 'store/interfaces';
    import {mapGetters, mapActions} from 'vuex'

    export default {
        name: "PlanDetails",
        data() {
            return {
                notice: {},
                tableData: [],
                page: {},
                planDetailStatus: planDetailStatus,
                planStatus: [],
                showBut: false,
                currentStatus: '',
                consumeMoney:0,
                dialogModel: {
                    amount: 0
                },
                dialogRules:{
                    amount: [{
                        required: true,
                        validator: (rule, value, callback) => {
                            if (!value) {
                                callback(new Error('请输入追回金额'))
                            } else{
                                if (value > (this.allMoney - this.alreadyMoney)){
                                    callback(new Error('追回金额不能大于总金额'))
                                }
                                return callback();
                            }
                        },
                    }],
                },
                dialogService: EmptyService.helpAdd,
                cashId:'',
                allMoney:0,
                alreadyMoney:0,
                item:{}
            }
        },
        mixins: [loadMixin, dialogMixin, validatorsMixin],
        components: {
            CommonTable, FormDialog
        },
        mounted() {
            // this.page = this.$refs.commonTable.page;
            this.item = this.$route.params.item;
            if (!this.item.id) {
                this.showWarming('数据丢失，请重新操作');
                this.$router.back();
            }

            this.allMoney = this.item.allMoney * 100 / 10000;
            this.alreadyMoney = this.item.alreadyMoney * 100 / 10000;

            this.getList();

            this.getTypeNames('计划状态', (res) => {
                this.planStatus = res;
            });
        },
        computed: {
            commonParams() {
                const params = {
                    userId: this.userId,
                    helpChaseMoneyId : this.item.id,
                };
                return params;
            },
            dialogData() {
                const params = {
                    helpChaseMoneyId: this.item.id,
                    money: this.dialogModel.amount,
                };
                return params;
            },
            ...mapGetters(['serverType', 'tatId', 'userId'])
        },
        methods: {
            handleSelectStatus() {
                this.$refs.formDialog.open();
            },
            dialogSuccess(data){
                this.showSuccess(data.respMsg);
                this.alreadyMoney += Number(this.dialogModel.amount);
                this.$refs.formDialog.closeDialog();
                this.isReloadPage(true);
                this.getList();
            },
            dialogClose(){
                this.dialogModel = {
                    amount:0
                }
            },
            formatTranTypee(row, column, cellValue) {
                return cellValue ? cellValue : '--';
            },
            getList() {
                this.doLoad(EmptyService.getChaseListDetail, this.commonParams, res => {
                    this.doCheck(res, res => {
                        const result = res.contents;
                        this.tableData = result;
                    });
                }, '信息获取失败')
            },
            ...mapActions({
                isReloadPage: StorageService.Reload.page,
            })
        }

    }
</script>

<style scoped>
    .plan-label {
        /*padding-left: 10%;*/
    }

    .plan-label p {
        margin: 10px 10px 20px;
    }

    .plan-label p span {
        color: rgba(170, 170, 170, 1);
    }

    .button-size {
        width: 120px;
        margin-bottom: 30px;
    }

</style>



// WEBPACK FOOTER //
// src/view/page/TransactionManage/EmptyCashPlanDetails.vue